import { NVButton } from '@nv/basic-components'
import XIcon from '@nv/images/design/x-icon'
import styles from './ModalHeader.module.scss'

export const ModalHeader = ({ label = '', onClose, style = {} }) => {
  return (
    <div className={styles['container']} style={style}>
      <span className={styles['label']}>{label}</span>
      <NVButton variant='iconOnly' onClick={onClose} icon={<XIcon />} />
    </div>
  )
}
